import type { AdvanceFilter } from '@/_containers';

import { CustomFilterWithRadios } from './custom-filter-with-radios';

import type { InvoiceFilterSchema } from '../../shared/filters';

export function filterRenderer(
  f: AdvanceFilter<InvoiceFilterSchema>,
  handleSubmitAdvFilters: (v: AdvanceFilter<InvoiceFilterSchema>) => void
) {
  return <CustomFilterWithRadios {...f} handleSubmitAdvFilters={handleSubmitAdvFilters} />;
}
